import { useMemo } from "react";
import { Loader2 } from "lucide-react";
import { DataTable } from "@/components/ui/data-table";
import type { StockArticle } from "@/lib/stock.api";
import { createStockArticleColumns } from "../stockArticleColumns";
import { StockArticleGrid } from "./StockArticleGrid";

interface StockArticlesTabContentProps {
  articles: StockArticle[];
  isMobile: boolean;
  isLoading: boolean;
  canManage: boolean;
  toggling: boolean;
  onSelect: (article: StockArticle) => void;
  onToggleActive: (article: StockArticle) => void;
  onEdit: (article: StockArticle) => void;
  onRestock: (article: StockArticle) => void;
}

export function StockArticlesTabContent({
  articles,
  isMobile,
  isLoading,
  canManage,
  toggling,
  onSelect,
  onToggleActive,
  onEdit,
  onRestock,
}: StockArticlesTabContentProps) {
  const columns = useMemo(
    () => createStockArticleColumns({ canManage, toggling, onToggleActive, onEdit, onRestock }),
    [canManage, onToggleActive, onEdit, onRestock, toggling],
  );

  if (isMobile) {
    if (isLoading) return <Loader2 className="animate-spin text-subtle" size={18} />;
    return (
      <StockArticleGrid
        articles={articles}
        canManage={canManage}
        toggling={toggling}
        onSelect={onSelect}
        onToggleActive={onToggleActive}
        onEdit={onEdit}
        onRestock={onRestock}
      />
    );
  }

  return (
    <DataTable
      columns={columns}
      data={articles}
      loading={isLoading}
      emptyMessage="Aucun article."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
